import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'

import BodyText from 'LuxKit/Typography/BodyText'
import Label from 'LuxKit/Label/Label'
import Pane from 'components/Common/Pane/Pane'
import Group from 'components/utils/Group'
import NumberRating from 'components/Common/NumberRating/NumberRating'

const Container = styled(Pane)`
  padding: ${rem(16)} ${rem(20)};
`

const RatingWrapper = styled.div`
  flex-shrink: 0;
  white-space: nowrap;
`

interface Props {
  content: string
  score: number
  reviewsTotal: number
}

function OfferPageReviewAiSummary({
  content,
  score,
  reviewsTotal,
}: Props) {
  const intl = useIntl()

  return (
    <Container background="neutral-seven">
      <Group direction="horizontal" gap={20} verticalAlign="start">
        <RatingWrapper>
          <NumberRating
            link
            rating={score}
            total={reviewsTotal}
            variant="xl"
            hideLabel
            layout="vertical"
          />
        </RatingWrapper>
        <Group direction="vertical" gap={8}>
          <Group direction="horizontal" gap={8} verticalAlign="center">
            <BodyText variant="large" weight="bold">
              {intl.formatMessage({
                id: 'J9BaGeQpru',
                defaultMessage: 'What guests say',
                description: 'Title for the AI-generated review summary section',
              })}
            </BodyText>
            <Label kind="secondary" variant="grey">
              {intl.formatMessage({
                id: 'UqAneTmAbh',
                defaultMessage: 'AI summary',
                description: 'Label indicating the summary is AI-generated',
              })}
            </Label>
          </Group>
          <BodyText variant="medium" colour="neutral-two">{content}</BodyText>
        </Group>
      </Group>
    </Container>
  )
}

export default React.memo(OfferPageReviewAiSummary)
